/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { PreviousStatesResponse } from '../../models/previous-states-response';

export interface DeliveryControllerFindDeliveryPreviousStatuses$Params {
  id: number;
}

export function deliveryControllerFindDeliveryPreviousStatuses(http: HttpClient, rootUrl: string, params: DeliveryControllerFindDeliveryPreviousStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PreviousStatesResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, deliveryControllerFindDeliveryPreviousStatuses.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: PreviousStatesResponse;
      }>;
    })
  );
}

deliveryControllerFindDeliveryPreviousStatuses.PATH = '/delivery/previous-nodes/{id}';
